@if (landingpageConfig(); as _landingpageConfig) {
  @let _customer = _landingpageConfig.customer;
  <ez-main-layout [landingpageConfig]="_landingpageConfig" [theme]="Themes.NONE">
    <ez-banner>
      <span ngProjectAs="title">
        {{ _landingpageConfig.organisation.customFields['title'] || 'Ihr Versicherungs&shy;beitrag' }}
      </span>
      <span ngProjectAs="subtitle">
        {{ _landingpageConfig.organisation.customFields['subtitle'] || 'Jetzt unkompliziert bezahlen' }}
      </span>
    </ez-banner>
    <div class="paypal-detail-container">
      <button id="back-top-button" (click)="onBackToOverview()">
        <span class="material-symbols-outlined" aria-hidden="true">arrow_back</span>
        <span class="text--bold"> Zahlungsmethoden</span>
      </button>

      <p>
        {{ _landingpageConfig.organisation.customFields['customerNumberLabel'] || 'Kundennummer' }}:
        {{ _customer.customerNumber }}
      </p>

      <h2>Zahlen via PayPal</h2>

      <ez-fee-info-box
        [organisation]="_landingpageConfig.organisation"
        [name]="isPrivateCustomer(_customer) ? _customer.firstName + ' ' + _customer.lastName : _customer.companyName"
        [dueDate]="earliestDueDate()"
        [amountInEuro]="_landingpageConfig.totalAmount"
        [customerNumber]="_customer.customerNumber"
      ></ez-fee-info-box>

      <ngx-paypal [config]="paypalConfig()"></ngx-paypal>
      @if (errorMessage(); as _message) {
        <span class="error-message">{{ _message }}</span>
      }

      <ez-contact
        [organisation]="_landingpageConfig.organisation"
        [customData]="_landingpageConfig.customData"
        teaser="{{
          _landingpageConfig.organisation.customFields['contactTeaser'] ||
            'Sie haben schon gezahlt oder möchten noch Fragen mit uns klären? Sie können nur einen Teil des Beitrags zahlen? <br> <br> Dann rufen Sie uns bitte an:'
        }}"
        subtitle="{{ _landingpageConfig.organisation.customFields['contactSubtitle'] }}"
        phonePrefix="{{ _landingpageConfig.organisation.customFields['contactPhonePrefix'] || 'Kundenservice: ' }}"
        withContactForm="false"
      ></ez-contact>
    </div>
  </ez-main-layout>
}
